<template>
  <div class="modal fade" ref="contactModal" id="contact-modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 style="color: #000; font-size: 22px; padding: 0; margin: 0; text-align: center;">Attention</h3>
        </div>
        <div class="modal-body clearfix">
          <div class="modal-page" v-if="activePage === 1">
            <p>Are you requesting information about your W-9 or the W-9 process?</p>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="requesting-info" id="contact-yes" value="yes" @change="showPage(2)">
              <label class="form-check-label" for="contact-yes">
                Yes
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="requesting-info" id="contact-no" value="no" @change="showContent">
              <label class="form-check-label" for="contact-no">
                No
              </label>
            </div>
          </div>
          <div class="modal-page" v-if="activePage === 2">
            <p>Do you currently have rewards to redeem?</p>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="points" id="points-yes" value="yes" :checked="false" @change="showPage(3)">
              <label class="form-check-label" for="points-yes">
                Yes
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="points" id="points-no" value="no" :checked="false" @change="showPage(4)">
              <label class="form-check-label" for="points-no">
                No
              </label>
            </div>
          </div>
          <div class="modal-page" v-if="activePage === 3">
            <p>Click <a href="javascript:void(0)" @click="showCashinModal">here</a> to visit CA$H IN.</p>
          </div>
          <div class="modal-page" v-if="activePage === 4">
            <p>Click <a href="/1099">here</a> to visit the Employee ID & Incentive Registration page for more information. Please come back to the CA$H IN form when you have rewards to fill out the W-9.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '../event-bus';

export default {
  props: {
    sent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activePage: 1
    }
  },
  mounted() {
    if (this.sent) {
      eventBus.$emit('showContent', 'contact');
    } else {
      $(this.$refs.contactModal).modal({backdrop: 'static', keyboard: false, show: true});
    }
  },
  methods: {
    showContent() {
      eventBus.$emit('showContent', 'contact');

      $(this.$refs.contactModal).modal('hide');
    },
    showPage(page) {
      this.activePage = page;
    },
    showCashinModal() {
      $('#verify-employee-id-modal').modal('show');
      $(this.$refs.contactModal).modal('hide');
    }
  }
}
</script>